import moment from 'moment-timezone';
import { OpeningHoursWithExceptions } from 'common/types';
import { getOpeningTimesForDate } from 'common/utils/shopUtils';
import { TimeSlotType } from './types';

export const getIntervalTimeSlotsForDate = (
	date: moment.Moment,
	_startIntervalMinutes: number | null,
	openingHoursWithExceptions: OpeningHoursWithExceptions,
	timeSlotType: TimeSlotType['type'],
) => {
	const openingTimes = getOpeningTimesForDate(date, openingHoursWithExceptions);
	if (!openingTimes || openingTimes.isClosed) {
		return [];
	}
	const startTimeIntervalMinutes = _startIntervalMinutes ?? 60;
	const { openTime, closeTime } = openingTimes;
	const [openingHour, openingMinute] = openTime.split(':').map((val) => Number(val));
	const [closingHour, closingMinute] = closeTime.split(':').map((val) => Number(val));
	return getTimeSlotsWithinOpeningHours({
		openingHoursMinutes: [openingHour, openingMinute],
		closingHourMinutes: [closingHour, closingMinute],
		startTimeIntervalMinutes,
		timeSlotType,
	});
};

export const getTimeSlotsWithinOpeningHours = (args: {
	openingHoursMinutes: [number, number];
	closingHourMinutes: [number, number];
	startTimeIntervalMinutes: number;
	timeSlotType: TimeSlotType['type'];
}) => {
	const { openingHoursMinutes, closingHourMinutes, startTimeIntervalMinutes, timeSlotType } = args;
	const [openingHour, openingMinute] = openingHoursMinutes;
	const [closingHour, closingMinute] = closingHourMinutes;
	if (
		openingHour > closingHour ||
		(openingHour === closingHour && openingMinute >= closingMinute)
	) {
		return [];
	}
	const closingHourIncluded =
		closingMinute - openingMinute > 0 ||
		(closingMinute - openingMinute === 0 && timeSlotType === 'endTime');
	const timeSlotCount =
		Math.ceil(((closingHour - openingHour) * 60) / startTimeIntervalMinutes) +
		(closingHourIncluded ? 1 : 0);
	return Array.from(Array(timeSlotCount).keys()).map((slot) =>
		moment()
			.hour(openingHour)
			.minute(slot * startTimeIntervalMinutes + openingMinute)
			.format('HH:mm'),
	);
};
